<!--
this just displays the email
slider
//https://www.w3schools.com/howto/howto_js_rangeslider.asp
-->
<script>
   import { cpu_speed, min_speed, max_speed, app_themes, app_theme, user_levels, play_sound } from './stores.js';
   import {LevelsID} from './Levels.svelte';
   
   import {Buffer} from 'buffer/';
   
   let CPUSpeed = $cpu_speed;
   let files;
   let Status = '';
   
   function ChangeSpeed()
   {
       cpu_speed.set(parseInt(CPUSpeed));
       return;
   }
   function ChangeTheme()
   {
       //alert(ThemeSelect);
       var newt = document.getElementById('theme').value;
       app_theme.set(parseInt(newt));
       //document.getElementById("console").className = "crt";
       return;
   }
   function ChangeSound()
   {
       //alert(document.getElementById('sound').checked);
       play_sound.set(document.getElementById('sound').checked);
       return;
   }
   
   //save with js pickle https://github.com/sciyoshi/pickle-js/blob/master/pickle.js
   //https://stackoverflow.com/questions/11071473/how-can-javascript-save-to-a-local-file
   //https://github.com/javascript-obfuscator/javascript-obfuscator
   //convert to 64 https://github.com/flesch/base64json?tab=readme-ov-file
   function SaveDataToFile()
   {
       
       //convert json to base 64
       let encoded = Buffer.from(JSON.stringify($user_levels), 'ascii').toString('base64');
       var bb = new Blob([encoded], { type: 'text/plain' });
       
       //json
       //let u = $user_levels;
       //var bb = new Blob([JSON.stringify(u)], { type: 'text/plain' });
       
       //save variable bb as a file
       let a = document.createElement('a');
       a.download = 'TIS10.sav';
       a.href = window.URL.createObjectURL(bb);
       a.click();
       a.remove();
       
   }
   
   //users can save source code
   function SaveCodeToFile()
   {
       let output = "";
       
       for (var key in $user_levels) {
          if($user_levels[key].id in LevelsID)
          {
              output = output + LevelsID[$user_levels[key].id].Name + '\n';
              output = output + $user_levels[key].program + '\n\n\n'; 
          }
        }
       var bb = new Blob([output], { type: 'text/plain' });
       //save variable bb as a file
       let a = document.createElement('a');
       a.download = 'TIS10.txt';
       a.href = window.URL.createObjectURL(bb);
       a.click();
       a.remove();
       
   }
   
   async function LoadDataFromFile(file)
   {
       let text = await files[0].text();
       
       //json
       //$user_levels = JSON.parse(text);
       //alert(JSON.stringify($user_levels));
       
       //buffer converts to base 64
       $user_levels = JSON.parse(Buffer.from(text, 'base64').toString('ascii'));
       //alert(JSON.stringify($user_levels));

       //status for user
       Status = 'File loaded';
   }
   
   
   //https://stackoverflow.com/questions/65127914/displaying-file-content-in-svelte
   $: if (files) {
       LoadDataFromFile(files[0]);
   }
</script>
<style>

.options{
    width:400px;
    background-color:#000;
    font-weight:bold;
    table-layout:fixed;
}

.options td{
    height: 60px;
    padding:5px;
}

#main{
    text-align:left;
    font-weight:bold;
    width: 450px;
    margin:auto auto;
    font-size:16px;
}

.lefttd {
    font-weight: bold;
    width: 130px;
    text-align:right;
}

/*Toggle stuff*/
 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.toggle:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .toggle {
  background-color: #2196F3;
}

input:focus + .toggle {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .toggle:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.toggle.round {
  border-radius: 34px;
}

.toggle.round:before {
  border-radius: 50%;
}
/***********************************/
/*slider stuff*/
.slidecontainer {
    width: 100%;
}

.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 25px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

.slider:hover {
    opacity: 1;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: #04AA6D;
    cursor: pointer;
}

.slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: #04AA6D;
    cursor: pointer;
}
</style>

<div id="main">
    <h3>- Settings -</h3>
    <table class="options" align="center" cellpadding="10" cellspacing="10">
        <tr><td class="lefttd">Play Sounds</td><td>
            <label class="switch">
                {#if $play_sound==true}
                    <input type="checkbox" id="sound" checked on:change={ChangeSound}>
                {:else}
                    <input type="checkbox" id="sound" on:change={ChangeSound}>
                {/if} 
              <span class="toggle round"></span>
            </label></td></tr>
        <tr><td class="lefttd">CPU Speed</td>
            <td>
            <div class="slidecontainer">
                  <input type="range" min={$min_speed} max={
                  $max_speed} bind:value={CPUSpeed} on:click={ChangeSpeed}>
                </div>
                </td></tr>
        <!--<tr><td class="lefttd">Theme</td><td>
            <select id="theme" name="theme" on:change={ChangeTheme}>
                {#each $app_themes as name, i}
                    {#if i==$app_theme} 
                        <option value={i} selected>{name}</option>
                    {:else}
                        <option value={i} >{name}</option>
                    {/if} 
                {/each}
            </select>
            </td></tr>-->
        <tr><td class="lefttd">Save Progress</td>
            <td><button type="button" on:click={SaveDataToFile}>Click to Save</button></td></tr>
        <tr><td class="lefttd">Load Progress</td>
            <td><input type='file' bind:files style="width:280px"></td></tr>
        <tr><td class="lefttd"></td>
            <td style="color:#00FF00">{@html Status}</td></tr>
        <tr><td class="lefttd">Save Code</td>
            <td><button type="button" on:click={SaveCodeToFile}>Click to Save</button></td></tr>
    </table>

</div>